const button = {
  // 1. We can update the base styles
  baseStyle: {
    fontWeight: '500',
    borderRadius: '0',
  },
  // 2. We can add a new button size or extend existing
  sizes: {
    xl: {
      h: '56px',
      fontSize: 'lg',
      px: '32px',
    },
  },
  // 3. We can add a new visual variant
  variants: {
    solid: () => ({
      bg: 'brand',
      color: 'contrast',
      _hover: {
        bg: 'brand.dark',
      },
    }),
    ghost: () => ({
      color: 'text',
      _hover: {
        bg: 'lightContrast',
      },
    }),
    outline: () => ({
      bg: 'transparent',
      color: '#000',
      borderColor: '#000',
      _hover: {
        bg: '#000',
        color: '#fff',
      },
    }),
  },
};

export default button;
